import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../..';
import Checkbox from '../../../Components/Checkbox/Checkbox';
import Spinner from '../../../Components/Spinner/Spinner';
import Item from './Item/Item';

const Cfc = () => {
	const { t } = useTranslation();
	const [cfcs, setCfcs] = useState([]);
	const [sounds, setSounds] = useState([]);
	const [loading, setLoading] = useState(true);
	const [isEdit, setIsEdit] = useState(false);

	useEffect(() => {
		if(api.accessToken) {
			getData();
		}
	}, [])

	const getData = () => {
		api.calls.company.soundFile.browse()
		.then((r: any) => {
			setSounds(r.data);
			setLoading(false);
		});

		api.calls.cfc.browse()
		.then((r: any) => {
			setCfcs(r.data);
			setLoading(false);
		});
	}

	const soundOptions:any = [];

	if(sounds.length !== 0) {
		for(const s of sounds) {
			soundOptions.push(
				{value: s['id'], label: s['name']}
			)
		}
	}

	if(loading) {
		return <div className="callout">
			<div className="cfc">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

	return <div className="callout">
		<div className="cfc">
			<div className="row">
				<div className="small-12 medium-12 large-12 columns">
					<p>{t('cfc_first_message')}</p>
					<div className="row">
						<div className="small-2 columns checkbox-container">
							<Checkbox
								label={t('change_audio_file')}
								checked={isEdit}
								onChange={(checked: boolean) => {
									setIsEdit(checked);
								}}
								disabled={!loading && cfcs.length === 0}
							/>
						</div>
						<div className="small-10 columns"></div>
					</div>
					<p className="text-message">{t('cfc_second_message')}</p>

					<table className="unstriped">
						<thead>
							<tr>
								<th>
									<b>{t('state')}</b>
								</th>
								<th>
									<b>{t('name')}</b>
								</th>
								<th>
									<b>{t('used_in')}</b>
								</th>
								<th>
									<b>{t('active')}</b>
								</th>
								<th>
									<b>{t('inactive')}</b>
								</th>
							</tr>
						</thead>
						<tbody>
							{
								cfcs.length !== 0 ?
									cfcs.map((cfc:any) => <Item
										key={cfc.id}
										soundOptions={soundOptions}
										cfc={cfc}
										isEdit={isEdit}
									/>)
								:
									<tr>
										<td className="center" colSpan={5}>{t('no_data_found')}</td>
									</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
}

export default Cfc;
